import { useCallback, useEffect, useState } from 'react';

export const useClientDirectory = (token, apiFetch) => {
  const [members, setMembers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const refreshMembers = useCallback(async () => {
    setError('');
    try { setMembers(await apiFetch('/clients', {}, token)); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }, [token, apiFetch]);
  useEffect(() => { refreshMembers(); }, [refreshMembers]);
  const addMember = async data => {
    const client = await apiFetch('/clients', { method: 'POST', body: JSON.stringify(data) }, token);
    setMembers(previous => [...previous, client]);
  };
  const editMember = async (id, data) => {
    const client = await apiFetch(`/clients/${id}`, { method: 'PATCH', body: JSON.stringify(data) }, token);
    setMembers(previous => previous.map(item => item.id === id ? client : item));
  };
  const archiveMember = async id => {
    await apiFetch(`/clients/${id}/archive`, { method: 'PATCH' }, token);
    setMembers(previous => previous.filter(item => item.id !== id));
  };
  return { members, addMember, editMember, archiveMember, refreshMembers, error, loading };
};